import { forwardRef } from "react";
import { Link, type LinkProps } from "react-router-dom";

export type SmoothLinkProps = LinkProps;


/**
 * SmoothLink - Simple Link wrapper for consistency
 * 
 * Uses standard react-router-dom Link for navigation.
 * ScrollToTop component in App.tsx handles smooth scroll-to-top on route change.
 */

const SmoothLink = forwardRef<HTMLAnchorElement, LinkProps>(
  (props, ref) => {
    return <Link ref={ref} {...props} />;
  }
);

SmoothLink.displayName = "SmoothLink";

export { SmoothLink };

